import axios from 'axios';
import { base } from '../../../config/config';

class Result {
  constructor(tvShows, pages, totalRes) {
    this.tvShows = tvShows;
    this.pages = pages;
    this.totalRes = totalRes;
  }
}

export default {
  state: {
    popular: {
      tvShows: [],
      pages: '',
      totalRes: '',
    },
    airingToday: {
      tvShows: [],
      pages: '',
      totalRes: '',
    },
    onTheAir: {
      tvShows: [],
      pages: '',
      totalRes: '',
    },
    latest: {
      tvShows: [],
      pages: '',
      totalRes: '',
    },
    topRated: {
      tvShows: [],
      pages: '',
      totalRes: '',
    },
    homePrev: {
      popular: {
        tvShows: [],
      },
      onTheAir: {
        tvShows: [],
      },
      airingToday: {
        tvShows: [],
      },
      latest: {
        tvShows: [],
      },
    },
  },
  mutations: {
    setTVResults(state, { result, category, home }) {
      let stateObject;

      if (!home) {
        switch (category) {
          case 'popular':
            stateObject = state.popular;
            break;
          case 'airing_today':
            stateObject = state.airingToday;
            break;
          case 'on_the_air':
            stateObject = state.onTheAir;
            break;
          case 'latest':
            stateObject = state.latest;
            break;
          case 'top_rated':
            stateObject = state.topRated;
            break;
          default:
            stateObject = state.popular;
        }

        result.tvShows.forEach((element) => {
          stateObject.tvShows.push(element);
        });
        stateObject.pages = result.pages;
        stateObject.totalRes = result.totalRes;
      } else {
        switch (category) {
          case 'popular':
            stateObject = state.homePrev.popular;
            break;
          case 'on_the_air':
            stateObject = state.homePrev.onTheAir;
            break;
          case 'airing_today':
            stateObject = state.homePrev.airingToday;
            break;
          case 'latest':
            stateObject = state.homePrev.latest;
            break;
          default:
            stateObject = state.homePrev.popular;
        }

        stateObject.tvShows = result.tvShows.slice(0, 6);
      }
    },
  },
  actions: {
    async getTVResults({ commit }, { category, page = 1, home = null }) {
      commit('clearError');
      commit('setLoading', true);

      // console.log('fetching tvShow results for category: ', category);

      try {
        const url = `${base.urlPrefix}/tv/${category}?api_key=${base.key}&${
          base.language
        }&page=${page}&${base.region}`;

        const response = await axios.get(url);
        const { data } = response;

        const result = new Result(
          data.results,
          data.total_pages,
          data.total_results,
        );

        commit('setTVResults', { result, category, home });
        commit('setLoading', false);
      } catch (error) {
        commit('setError', `Uups! Da is was schief gelaufen: ${error.message}`);
        commit('setLoading', false);
      }
    },
  },
  getters: {
    getQuickTotalTVRes(state) {
      return (pageName) => {
        switch (pageName) {
          case 'popular':
            return state.popular.totalRes;
          case 'on_the_air':
            return state.onTheAir.totalRes;
          case 'airing_today':
            return state.airingToday.totalRes;
          case 'latest':
            return state.latest.totalRes;
          default:
            return state.popular.totalRes;
        }
      };
    },
  },
};
